import { render, staticRenderFns } from "./CommercialInfo.vue?vue&type=template&id=162fc95e&scoped=true&lang=pug&"
import script from "./CommercialInfo.vue?vue&type=script&lang=js&"
export * from "./CommercialInfo.vue?vue&type=script&lang=js&"
import style0 from "./CommercialInfo.vue?vue&type=style&index=0&id=162fc95e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162fc95e",
  null
  
)

component.options.__file = "CommercialInfo.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VDivider,
  VFlex,
  VForm,
  VIcon,
  VLayout,
  VSwitch,
  VTooltip,
})
